import { toRefs, ref, computed, onMounted } from 'vue';
import uniqueId from 'lodash/uniqueId';
import { useTwitchApi } from '../../compositions/component-lib.esm9.js';
import { useMounted } from '../../compositions/component-lib.esm4.js';
import { defaultWindow } from '../../utils/component-lib.esm5.js';
import { EVENTS } from '../../config/component-lib.esm.js';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    embedType: {
      type: String,
      required: true
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      id,
      embedType
    } = toRefs(props);
    const player = ref(null);
    const videoStarted = ref(false);
    const window = defaultWindow;
    const isMounted = useMounted();
    const playerId = ref(uniqueId('player'));
    const layout = computed(() => {
      return embedType.value === 'embed_channel_chat' ? 'video-with-chat' : 'video';
    });
    function loadVideo() {
      if (embedType.value === 'embed_chat' || !isMounted.value) return;
      player.value = new Twitch.Embed(playerId.value, {
        channel: id.value,
        height: '100%',
        width: '100%',
        autoplay: false,
        referrer: location.toString(),
        layout: layout.value
      });
      subscribe();
    }
    function subscribe() {
      player.value.addEventListener(Twitch.Player.PLAYING, () => {
        if (!videoStarted.value) emit('event', EVENTS.VIDEO_STARTED);
        emit('event', EVENTS.VIDEO_PLAYING);
        videoStarted.value = true;
      });
      player.value.addEventListener(Twitch.Player.PAUSE, () => emit('event', EVENTS.VIDEO_PAUSED));
      player.value.addEventListener(Twitch.Player.ENDED, () => emit('event', EVENTS.VIDEO_ENDED));
    }
    useTwitchApi(loadVideo);
    onMounted(() => {
      if (window && window.Twitch) loadVideo();
    });
    return {
      playerId,
      location: location.hostname
    };
  }
};
export { script as default };